// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kr-container {
  container-type: inline-size;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  cursor: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.kr-container .kr-content-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  overflow-x: hidden;
  max-width: 100%;
}

.kr-container .kr-gauges-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 20px;
  flex: 1 1 auto;
  min-height: 0;
}

.kr-container .kr-gauge-item {
  min-height: 200px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.kr-container .kr-bars-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

.kr-container .kr-bar-item {
  flex: 1 1 calc(50% - 10px);
  min-height: 200px;
  min-width: 0;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  background-color: #f9f9f9;
  padding: 24px;
  box-sizing: border-box;
  overflow: hidden;
}

@container (min-width: 768px) {
  .kr-container .kr-bar-item {
    flex-basis: calc(25% - 15px);
  }
}

.kr-container .kr-bar-item-title {
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: var(--text-primary);
  text-align: left;
}

.kr-container .kr-bar-item-title-suffix {
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  color: var(--text-primary);
}

.kr-container .kr-bar-item-name {
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  color: var(--text-secondary);
  text-align: left;
  overflow-wrap: anywhere;
}

.kr-container .kr-bar-item-value {
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  color: var(--text-primary);
  text-align: left;
}

.kr-container .kr-legend {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  padding-top: 10px;
}

.kr-container .kr-legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.kr-container .kr-legend-color {
  width: 12px;
  height: 12px;
  border-radius: 2px;
}

.kr-container .kr-legend-label {
  font-size: 12px;
  color: var(--text-primary);
}

.kr-container .kr-table-container {
  overflow-y: auto;
  overflow-x: auto;
  flex: 1 1 auto;
  min-height: 0;
}

.kr-container .kr-table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0px;
}

.kr-container .kr-table thead th {
  border-bottom: 1px solid var(--border-primary);
  padding-top: 8px;
  padding-bottom: 8px;
  text-align: right;

  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
  color: var(--text-instrument);
  vertical-align: bottom;
  white-space: nowrap;
}

.kr-container .kr-table thead th:first-child {
  width: 22px;
  border: none;
}

.kr-container .kr-table thead th:last-child {
  width: 22px;
  border: none;
}

.kr-container .kr-table tbody td {
  vertical-align: middle;
  border-bottom: 1px solid var(--border-tertiary);
  min-height: 56px;
  max-height: 72px;
  height: 56px;
}

.kr-container .kr-table tbody td:first-child {
  width: 22px;
  border: none;
}

.kr-container .kr-table tbody td:last-child {
  width: 22px;
  border: none;
}

.kr-table-header {
  padding: 8px 0;
  text-align: left;

  font-size: 16px;
  color: var(--text-instrument);
}

.kr-currency-label {
  font-size: 12px;
  font-weight: 400;
}

.kr-container .kr-table thead th.kr-table-header-year {
  text-align: right;
  padding: 8px 8px;
  min-width: 100px;
  max-width: 100px;
  border-bottom: 1px solid var(--border-primary);
}

.kr-container .kr-table thead th.kr-table-header-label {
  text-align: left;
  padding: 8px 8px;
  min-width: 180px;
  max-width: 180px;
  border-bottom: 1px solid var(--border-primary);
}

.kr-header-content {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
}

.kr-header-fy {
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  color: var(--text-subheader);
}

.kr-header-date {
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: var(--text-subheader);
}

.kr-container .kr-table tbody td {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  vertical-align: middle;
  text-align: right;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0;
  color: var(--text-primary);
  padding: 8px 8px;
  box-sizing: border-box;
}

.kr-container .kr-table tbody td.kr-table-label-cell {
  text-align: left;
  padding-left: 8px;
  min-width: 180px;
  max-width: 180px;
}

.kr-container .kr-table tbody td.kr-table-cell {
  text-align: right;
  padding-right: 8px;
  min-width: 100px;
  max-width: 100px;
}

.kr-label-with-icon {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
}

.kr-expand-icon {
  width: 16px;
  height: 16px;
  transition: transform 0.2s ease;
  transform: rotate(-90deg);
  flex-shrink: 0;
  color: var(--text-primary);
  path {
    fill: currentColor;
  }
}

.kr-expand-icon.expanded {
  transform: rotate(0deg);
}

.kr-label-text {
  font-size: 16px;
  line-height: 24px;
  color: var(--text-primary);
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  max-width: 100%;
}

.kr-indented-label {
  font-size: 16px;
  line-height: 24px;
  padding-left: 32px !important;
}

.kr-cell-content {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-top: 12px;
  padding-bottom: 12px;
}

.kr-cell-value {
  font-size: 16px;
  line-height: 18px;
  color: #1e1f2f;
}

.kr-cell-growth {
  font-size: 14px;
  line-height: 14px;
  font-weight: 400;
}

.kr-cell-growth.positive {
  color: var(--text-up-color);
}

.kr-cell-growth.negative {
  color: var(--text-down-color);
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/KeyRatiosWidget/KeyRatiosWidget.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,SAAS;EACT,cAAc;EACd,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;EAC9C,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;;EAEjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,6BAA6B;EAC7B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,+CAA+C;EAC/C,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;;EAEhB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,+CAA+C;EAC/C,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,yBAAyB;EACzB,cAAc;EACd,0BAA0B;EAC1B;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".kr-container {\n  container-type: inline-size;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  cursor: auto;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.kr-container .kr-content-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  flex: 1 1 auto;\n  min-height: 0;\n  height: 100%;\n  padding: 20px;\n  box-sizing: border-box;\n  overflow-x: hidden;\n  max-width: 100%;\n}\n\n.kr-container .kr-gauges-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-rows: repeat(2, 1fr);\n  gap: 20px;\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.kr-container .kr-gauge-item {\n  min-height: 200px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.kr-container .kr-bars-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.kr-container .kr-bar-item {\n  flex: 1 1 calc(50% - 10px);\n  min-height: 200px;\n  min-width: 0;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  background-color: #f9f9f9;\n  padding: 24px;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n@container (min-width: 768px) {\n  .kr-container .kr-bar-item {\n    flex-basis: calc(25% - 15px);\n  }\n}\n\n.kr-container .kr-bar-item-title {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 24px;\n  color: var(--text-primary);\n  text-align: left;\n}\n\n.kr-container .kr-bar-item-title-suffix {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 24px;\n  color: var(--text-primary);\n}\n\n.kr-container .kr-bar-item-name {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 20px;\n  color: var(--text-secondary);\n  text-align: left;\n  overflow-wrap: anywhere;\n}\n\n.kr-container .kr-bar-item-value {\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 24px;\n  color: var(--text-primary);\n  text-align: left;\n}\n\n.kr-container .kr-legend {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 24px;\n  padding-top: 10px;\n}\n\n.kr-container .kr-legend-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.kr-container .kr-legend-color {\n  width: 12px;\n  height: 12px;\n  border-radius: 2px;\n}\n\n.kr-container .kr-legend-label {\n  font-size: 12px;\n  color: var(--text-primary);\n}\n\n.kr-container .kr-table-container {\n  overflow-y: auto;\n  overflow-x: auto;\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.kr-container .kr-table {\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0px;\n}\n\n.kr-container .kr-table thead th {\n  border-bottom: 1px solid var(--border-primary);\n  padding-top: 8px;\n  padding-bottom: 8px;\n  text-align: right;\n\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0;\n  color: var(--text-instrument);\n  vertical-align: bottom;\n  white-space: nowrap;\n}\n\n.kr-container .kr-table thead th:first-child {\n  width: 22px;\n  border: none;\n}\n\n.kr-container .kr-table thead th:last-child {\n  width: 22px;\n  border: none;\n}\n\n.kr-container .kr-table tbody td {\n  vertical-align: middle;\n  border-bottom: 1px solid var(--border-tertiary);\n  min-height: 56px;\n  max-height: 72px;\n  height: 56px;\n}\n\n.kr-container .kr-table tbody td:first-child {\n  width: 22px;\n  border: none;\n}\n\n.kr-container .kr-table tbody td:last-child {\n  width: 22px;\n  border: none;\n}\n\n.kr-table-header {\n  padding: 8px 0;\n  text-align: left;\n\n  font-size: 16px;\n  color: var(--text-instrument);\n}\n\n.kr-currency-label {\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.kr-container .kr-table thead th.kr-table-header-year {\n  text-align: right;\n  padding: 8px 8px;\n  min-width: 100px;\n  max-width: 100px;\n  border-bottom: 1px solid var(--border-primary);\n}\n\n.kr-container .kr-table thead th.kr-table-header-label {\n  text-align: left;\n  padding: 8px 8px;\n  min-width: 180px;\n  max-width: 180px;\n  border-bottom: 1px solid var(--border-primary);\n}\n\n.kr-header-content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n}\n\n.kr-header-fy {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 18px;\n  color: var(--text-subheader);\n}\n\n.kr-header-date {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 14px;\n  color: var(--text-subheader);\n}\n\n.kr-container .kr-table tbody td {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  vertical-align: middle;\n  text-align: right;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: 0;\n  color: var(--text-primary);\n  padding: 8px 8px;\n  box-sizing: border-box;\n}\n\n.kr-container .kr-table tbody td.kr-table-label-cell {\n  text-align: left;\n  padding-left: 8px;\n  min-width: 180px;\n  max-width: 180px;\n}\n\n.kr-container .kr-table tbody td.kr-table-cell {\n  text-align: right;\n  padding-right: 8px;\n  min-width: 100px;\n  max-width: 100px;\n}\n\n.kr-label-with-icon {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.kr-expand-icon {\n  width: 16px;\n  height: 16px;\n  transition: transform 0.2s ease;\n  transform: rotate(-90deg);\n  flex-shrink: 0;\n  color: var(--text-primary);\n  path {\n    fill: currentColor;\n  }\n}\n\n.kr-expand-icon.expanded {\n  transform: rotate(0deg);\n}\n\n.kr-label-text {\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-primary);\n  font-weight: 700;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block;\n  max-width: 100%;\n}\n\n.kr-indented-label {\n  font-size: 16px;\n  line-height: 24px;\n  padding-left: 32px !important;\n}\n\n.kr-cell-content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n\n.kr-cell-value {\n  font-size: 16px;\n  line-height: 18px;\n  color: #1e1f2f;\n}\n\n.kr-cell-growth {\n  font-size: 14px;\n  line-height: 14px;\n  font-weight: 400;\n}\n\n.kr-cell-growth.positive {\n  color: var(--text-up-color);\n}\n\n.kr-cell-growth.negative {\n  color: var(--text-down-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
